import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import moment from "moment-timezone";
import EyeIcon from "mdi-material-ui/Eye";
import { useSelector } from "react-redux";
import IconButton from "@material-ui/core/IconButton";

import { queryInstances } from "../../../utils/appsyncOperations";
import * as constants from "../../../constants";
import ResponseDialog from "../../Dialogs/Response";

const SearchPropertyResponsesDialog = ({
  isOpen,
  onClose,
  propertyId,
  onSelectResponse,
}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [responses, setResponses] = useState([]);
  const [responseId, setResponseId] = useState(null);
  const snackbar = useSnackbar();

  const property = useSelector((state) => state.properties.byId[propertyId]);

  const queryResponses = async () => {
    setLoading(true);
    try {
      const responses = await queryInstances({ propertyId });
      setResponses(responses);
    } catch (e) {
      console.error(e);
      snackbar.enqueueSnackbar(e, { variant: "error" });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isOpen) {
      queryResponses();
    }
  }, [isOpen]);

  const renderListItems = () => {
    if (responses.length > 0) {
      return responses.map((response) => (
        <ListItem button onClick={() => onSelectResponse(response)}>
          <ListItemText
            primary={moment(response.createdAt)
              .tz(property.place.timezone)
              .format(constants.moment.format)}
            secondary={`ID: ${response.instanceId}`}
          />
          <ListItemSecondaryAction>
            <IconButton
              edge="end"
              onClick={() => setResponseId(response.instanceId)}
              color="inherit"
            >
              <EyeIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      ));
    } else {
      return (
        <ListItem>
          <ListItemText secondary={"No responses found."} />
        </ListItem>
      );
    }
  };

  return (
    <>
      <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>Search for a response report</DialogTitle>
        <DialogContent>
          {loading ? (
            <div className={classes.loadingContainer}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <List>{renderListItems()}</List>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <ResponseDialog
        isOpen={responseId !== null}
        onClose={() => setResponseId(null)}
        instanceId={responseId}
      />
    </>
  );
};

const useStyles = makeStyles(() => ({
  loadingContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
  },
}));

export default SearchPropertyResponsesDialog;
